<template>
  <div v-loading.fullscreen.lock="true">
  </div>
</template>
<script>
  import service from '@service/service'
  export default {
    created() {
      this.reqFpx(window.name);
    },

    methods: {
      async reqFpx(data) {
        await this.$http.post(service.payProcess, data, { 'Content-Type': 'application/xml' }).then((res) => {
          window.sessionStorage.setItem('sessionToken', res.token)
          this.$router.replace({ name: 'Login' })
        }).catch(error => {
          this.$router.replace({ name: 'SysError' })
        })
      },
    },
  }
</script>


// WEBPACK FOOTER //
// src/views/RequestFromFpx.vue